const routes = {
  dashboard: "/dashboard",
  mgaAssessment: "/assessment/:projectId/:designId/:designVersionId",
  mgaReports: "/assessment",
  mgaUserManagement: "/userManagement",
  mgaPreferences: "/userManagement",
  login: "/login",
  logout: "/logout",
  callback: "/callback",
  library: "/library",
  configurations: "/configurations",
};
const mgaConstants = {
  tabs: [
    {
      title: "Projects",
      to: routes.dashboard,
      ref: "mgaAssessment",
      Children: [],
    },
    {
      title: "Assets",
      to: routes.library,
      ref: "mgaAssessment",
      Children: [],
    },
  ],
  subMenus: [],
};

const mgaroles = {
  SecAdmin: "SecAdmin",
};

const assetLabels = {
  DegradationFactor: "Degradation Factor per year",
  MinPowerRate: "Minimum Power in % for Turn ON",
  MinimumRunTime: "Minimum Run Time Before Turn Off",
  LifetimeCycle: "Lifetime Charging and Discharging Cycles (Numbers)",
  LifetimeYear: "Life Time in Years",
  HeatRecoveryRatio: "Heat Recovery Ratio",
  PowerReserve: "Power Reserve in % of Load for Turn ON",
  "Fuel.Name": "Select Fuel Type",
  "Fuel.PricePerM3": "Price with drop down option for Litre or m3",
  FuelCurveSlope: "Slope Coefficient",
  FuelCurveIntercept: "Intercept Coefficient",
  PowElecNom: "Rated/ Nominal Power (kW)",

  EfficiencyDischarge: "Discharge Efficiency",
  EfficiencyCharge: "Charge Efficiency",
  SOCMax: "Maximum State Of Charge",
  SOCMin: "Minimum State Of Charge",
  CapaMax: "Rated/ Nominal Capacity",
  LifetimeHour: "Operational Lifetime (Run-Hours)",
  BatteryCapacity: "Battery Capacity",
  DrivingRange: "Driving Range",
  AvgConsumption: "Average Consumption",
  AcChargingPower: "AC Charging Power",
  DcFastCharging: "DC Fast Charging",
  ChargerEfficiency: "Charger Efficiency",
  PowElecNominalDischarge: "Nominal Discharging Power",
  PowElecNominalCharge: "Nominal Charge Power",
  MaximumCharge:"Nominal Charging Power"
};

export default Object.freeze({
  ...mgaConstants,
  routes,
  mgaroles,
  assetLabels
});
